module.exports = __webpack_public_path__ + "img/Girl_030019.b35f98bf.png";